import type { WithId } from '@medplum/core';
import type { Procedure } from '@medplum/fhirtypes';
import { useTranslation } from 'react-i18next';
import { ProceduresSummary } from './ProceduresSummary';
import type { PromotionStatus } from './RecordListItem';

export type ProceduresListProps = {
  procedures: WithId<Procedure>[];
  onSelectProcedure?: (procedureId: string) => void;
  selectedProcedureId?: string;
  onPromotionClick?: (id: string) => void;
  getPromotionStatus?: (id: string) => PromotionStatus;
};

export const ProceduresList = ({
  procedures,
  onSelectProcedure,
  selectedProcedureId,
  onPromotionClick,
  getPromotionStatus,
}: ProceduresListProps): React.ReactElement => {
  const { t } = useTranslation('records');

  return (
    <div className="mx-auto w-full max-w-4xl">
      {procedures.length > 0 ? (
        <ProceduresSummary
          procedures={procedures}
          onSelectProcedure={onSelectProcedure}
          selectedProcedureId={selectedProcedureId}
          onPromotionClick={onPromotionClick}
          getPromotionStatus={getPromotionStatus}
        />
      ) : (
        <p className="py-8 text-center text-sm text-muted-foreground">{t('noProceduresFound')}</p>
      )}
    </div>
  );
};
